import React from 'react'
import { createStyles, makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import Link from '../Link/Link'
import CMSText from '../Global/CMSText'
import Button from '../Button/Button'

const useStyles = makeStyles((theme) =>
  createStyles({
    alignCenter: {
      textAlign: 'center',
    },
    marginBottom: {
      marginBottom: theme.spacing(2),
    },
    hide: {
      opacity: 0,
      transition: theme.transitions.create('opacity'),
    },
    show: {
      opacity: 1,
      transition: theme.transitions.create('opacity'),
    },
  })
)

type Tprops = {
  isLoading: boolean
  defaultText: string
  data: any
  linkSSO: string
}

const SSOLink = ({ isLoading, defaultText, data, linkSSO }: Tprops) => {
  const classes = useStyles()
  return (
    <div className={clsx(classes.alignCenter, classes.marginBottom)}>
      <Link href={linkSSO}>
        <a>
          <Button component="span" variant={'contained'} color={'secondary'}>
            <span className={isLoading ? classes.hide : classes.show}>
              <CMSText asText defaultText={defaultText} data={data} />
            </span>
          </Button>
        </a>
      </Link>
    </div>
  )
}

export default SSOLink
